import { DefaultChatTransport } from "ai";
import { handleChatError } from "@/utils/chat-error-handler";

type UseChatConfigOptions = {
  apiUrl: string;
  apiKey: string;
  getContextUrl: () => string | undefined;
  getWidgetOrigin: () => string | undefined;
  onFinish?: () => void;
};

export const useChatConfig = ({
  apiUrl,
  apiKey,
  getContextUrl,
  getWidgetOrigin,
  onFinish,
}: UseChatConfigOptions) => {
  // Custom fetch that routes to the correct endpoint based on contextUrl and
  // injects the tenant Bearer token.
  const customFetch: (input: RequestInfo | URL, init?: RequestInit) => Promise<Response> = async (_input, init) => {
    const contextUrl = getContextUrl();

    const endpoint = contextUrl
      ? `${apiUrl}/v2/summarise-url`
      : `${apiUrl}/v2/completions`;

    const headers = new Headers(init?.headers);
    headers.set("Authorization", `Bearer ${apiKey}`);

    return fetch(endpoint, {
      ...init,
      headers,
    });
  };

  return {
    transport: new DefaultChatTransport({
      api: `${apiUrl}/v2/completions`, // Default (overridden by custom fetch)
      fetch: customFetch,
      body: () => ({
        widgetOrigin: getWidgetOrigin(),
        pagePathname: window.location.pathname,
      }),
    }),
    experimental_throttle: 100,
    onFinish,
    onError: (error: Error) => {
      handleChatError(error, "useChat");
    },
  };
};
